import { ChallengeService } from '@duck/api-definitions'

export interface PickResult {
  picked: ChallengeService.AvailableChallenge
  nextServed: string[]
}

/**
 * Picks a random challenge from `matches`, preferring ones whose taskId is not
 * already in `served`. When every match has been served, recycles by dropping
 * only this pool's taskIds from `served` (other match sets' history survives),
 * then picks again. Caller guarantees `matches.length > 0`.
 */
export const pickUnserved = (
  matches: ChallengeService.AvailableChallenge[],
  served: string[],
  random: () => number = Math.random,
): PickResult => {
  const servedSet = new Set(served)
  let base = served
  let pool = matches.filter((m) => !servedSet.has(m.taskId))

  if (pool.length === 0) {
    const poolIds = new Set(matches.map((m) => m.taskId))
    base = served.filter((id) => !poolIds.has(id))
    pool = matches
  }

  const picked = pool[Math.floor(random() * pool.length)]
  const nextServed = base.includes(picked.taskId) ? base : [...base, picked.taskId]
  return { picked, nextServed }
}
